'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./Github.css');

var _reactOcticons = require('react-octicons');

var _Tooltip = require('../Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Widget = require('../Widget/Widget');

var _Widget2 = _interopRequireDefault(_Widget);

var _GithubUser = require('../GithubUser/GithubUser');

var _GithubUser2 = _interopRequireDefault(_GithubUser);

var _GithubRepo = require('../GithubRepo/GithubRepo');

var _GithubRepo2 = _interopRequireDefault(_GithubRepo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Github = function (_Component) {
  _inherits(Github, _Component);

  function Github() {
    _classCallCheck(this, Github);

    var _this = _possibleConstructorReturn(this, (Github.__proto__ || Object.getPrototypeOf(Github)).call(this));

    _this.state = {
      tooltipIsOpen: false
    };

    _this.handleTooltipCloseTimeout = null;
    return _this;
  }

  _createClass(Github, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var isUser = typeof this.props.user === 'string';
      var isRepo = typeof this.props.repo === 'string';
      var isObjUser = _typeof(this.props.objUser) === 'object';
      var isObjRepo = _typeof(this.props.objRepo) === 'object';

      if (isRepo || isObjRepo) {
        isUser = false;
        isObjUser = false;
      }

      this.setState({
        isUser: isUser,
        isRepo: isRepo,
        isObjUser: isObjUser,
        isObjRepo: isObjRepo
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var isUser = typeof props.user === 'string';
      var isRepo = typeof props.repo === 'string';
      var isObjUser = _typeof(props.objUser) === 'object';
      var isObjRepo = _typeof(props.objRepo) === 'object';

      if (isRepo || isObjRepo) {
        isUser = false;
        isObjUser = false;
      }

      this.setState({
        isUser: isUser,
        isRepo: isRepo,
        isObjUser: isObjUser,
        isObjRepo: isObjRepo
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.handleTooltipCloseTimeout) {
        clearTimeout(this.handleTooltipCloseTimeout);
        this.handleTooltipCloseTimeout = null;
      }
    }
  }, {
    key: 'handleTooltipToggle',
    value: function handleTooltipToggle() {
      this.setState({
        tooltipIsOpen: !this.state.tooltipIsOpen
      });
    }
  }, {
    key: 'handleTooltipOpen',
    value: function handleTooltipOpen() {
      if (this.handleTooltipCloseTimeout) {
        clearTimeout(this.handleTooltipCloseTimeout);
        this.handleTooltipCloseTimeout = null;
      }
      this.setState({
        tooltipIsOpen: true
      });
    }
  }, {
    key: 'handleTooltipClose',
    value: function handleTooltipClose() {
      var _this2 = this;

      this.handleTooltipCloseTimeout = setTimeout(function () {
        _this2.setState({
          tooltipIsOpen: false
        });
      }, 50);
    }
  }, {
    key: 'handleTooltipMouseEnter',
    value: function handleTooltipMouseEnter() {
      if (this.props.tooltipOnHover !== false || this.props.type === 'link') {
        this.handleTooltipOpen();
      }
    }
  }, {
    key: 'handleTooltipMouseLeave',
    value: function handleTooltipMouseLeave() {
      if (this.props.tooltipOnHover !== false || this.props.type === 'link') {
        this.handleTooltipClose();
      }
    }
  }, {
    key: 'handleTooltipWindowActivate',
    value: function handleTooltipWindowActivate() {
      this.handleTooltipOpen();

      if (this.refButton) {
        this.refButton.focus();
      } else if (this.refLinkButton) {
        this.refLinkButton.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var type = this.props.type || 'widget';
      var tooltipPosition = 'auto';
      var child = null;

      if (this.state.isObjUser || this.state.isObjRepo) {
        if (this.state.isObjUser) {
          child = _react2.default.createElement(_GithubUser2.default, {
            objUser: this.props.objUser,
            type: type
          });
        } else if (this.state.isObjRepo) {
          child = _react2.default.createElement(_GithubRepo2.default, {
            objRepo: this.props.objRepo,
            type: type
          });
        }
      } else {
        if (this.state.isUser) {
          child = _react2.default.createElement(_GithubUser2.default, {
            name: this.props.user,
            type: type
          });
        } else if (this.state.isRepo) {
          child = _react2.default.createElement(_GithubRepo2.default, {
            repo: this.props.repo,
            type: type,
            user: this.props.user
          });
        }
      }

      // type
      if (type === 'button') {
        var tooltipProps = {
          parentClass: 'rsg-github-tooltip-button',
          color: this.props.iconColor,
          width: this.props.iconWidth ? this.props.iconWidth : '48px',
          height: this.props.iconHeight ? this.props.iconHeight : '48px'
        };

        if (this.props.fab) {
          tooltipProps.parentClass = tooltipProps.parentClass.concat('rsg-btn rsg-btn-fab');

          if (this.props.fabCorner) {
            tooltipProps.parentClass = tooltipProps.parentClass.concat(' rsg-btn-fab--' + this.props.fabCorner);
          } else {
            tooltipProps.parentClass = tooltipProps.parentClass.concat(' rsg-btn-fab--bottom-right');
          }
        }

        child = _react2.default.createElement(
          'div',
          { className: tooltipProps.parentClass },
          _react2.default.createElement(
            _Tooltip2.default,
            {
              anchor: this.refButton,
              onClick: function onClick() {
                return _this3.handleTooltipWindowActivate();
              },
              onMouseEnter: function onMouseEnter() {
                return _this3.handleTooltipWindowActivate();
              },
              onMouseLeave: function onMouseLeave() {
                return _this3.handleTooltipMouseLeave();
              },
              open: this.state.tooltipIsOpen,
              position: tooltipPosition
            },
            child
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'rsg-btn rsg-btn-icon',
              onBlur: function onBlur() {
                return _this3.handleTooltipClose();
              },
              onClick: function onClick() {
                return _this3.handleTooltipOpen();
              },
              onMouseEnter: function onMouseEnter() {
                return _this3.handleTooltipMouseEnter();
              },
              onMouseLeave: function onMouseLeave() {
                return _this3.handleTooltipMouseLeave();
              },
              ref: function ref(el) {
                return _this3.refButton = el;
              }
            },
            _react2.default.createElement(_reactOcticons.MarkGithubIcon, {
              fill: tooltipProps.color,
              height: tooltipProps.height,
              width: tooltipProps.width
            })
          )
        );
      } else if (type === 'link') {
        child = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Tooltip2.default,
            {
              anchor: this.refLinkButton,
              onMouseEnter: function onMouseEnter() {
                return _this3.handleTooltipMouseEnter();
              },
              onMouseLeave: function onMouseLeave() {
                return _this3.handleTooltipMouseLeave();
              },
              open: this.state.tooltipIsOpen,
              position: tooltipPosition
            },
            child
          ),
          _react2.default.createElement(
            'a',
            {
              className: 'rsg-inline-link rsg-github-tooltip-link',
              onMouseEnter: function onMouseEnter() {
                return _this3.handleTooltipMouseEnter();
              },
              onMouseLeave: function onMouseLeave() {
                return _this3.handleTooltipMouseLeave();
              },
              ref: function ref(el) {
                return _this3.refLinkButton = el;
              },
              style: { display: 'inline' }
            },
            this.props.linkText || 'Github'
          )
        );
      } else {
        child = _react2.default.createElement(
          _Widget2.default,
          null,
          child
        );
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'rsg-github rsg-github-tooltip-widget',
          id: this.props.id,
          style: this.props.style
        },
        child
      );
    }
  }]);

  return Github;
}(_react.Component);

Github.propTypes = {
  // fab
  fab: _propTypes2.default.bool,

  // fabCCorner
  fabCorner: _propTypes2.default.string,

  // iconColor
  iconColor: _propTypes2.default.string,

  // iconHeight
  iconHeight: _propTypes2.default.string,

  // iconWidth
  iconWidth: _propTypes2.default.string,

  // id
  id: _propTypes2.default.string,

  // linkText
  linkText: _propTypes2.default.string,

  // objRepo
  objRepo: _propTypes2.default.object,

  // objUser
  objUser: _propTypes2.default.object,

  // repo
  repo: _propTypes2.default.string,

  // style
  style: _propTypes2.default.string,

  // tooltipOnHover
  tooltipOnHover: _propTypes2.default.bool,

  // type
  type: _propTypes2.default.string,

  // user
  user: _propTypes2.default.string
};

exports.default = Github;